import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getOSHData } from '../../api';

class OSHAuthoritiesReport extends Component
{
    constructor(props)
	{
		super(props);

        const countryNames = {
            "AT":"39",
			"BE":"46",
			"BG":"56",
			"CH":"224",
			"CY":"77",
			"CZ":"78",
			"DE":"100",
			"DK":"79",
			"EE":"88",
			"EL":"103",
			"ES":"218",
			"FI":"93",
			"FR":"94",
			"HR":"75",
			"HU":"116",
			"IE":"122",
			"IS":"117",
			"IT":"125",
			"LT":"144",
			"LU":"145",
			"LV":"138",
			"MT":"153",
			"NL":"172",
			"NO":"182",
			"PL":"191",
			"PT":"192",
			"RO":"196",
			"SE":"223",
			"SI":"214",
			"SK":"213",
            "EU28":"264",
            "EU27_2020": "822"
        }

        this.state = {
            country: {
                countryName: countryNames[props.country],
                code: props.country
            },
            tableElements: {
                authorities: {
                    title: this.props.literals['L20003'],
                    nameText: this.props.literals['L20007'],
                    elements: []
                },
                compensationAndInsurance: {
                    title: this.props.literals['L20004'],
                    nameText: this.props.literals['L20008'],
                    elements: []
                },
                preventionInstitute: {
                    title: this.props.literals['L20005'],
                    nameText: this.props.literals['L20009'],
                    elements: []
                },
                standardisation: {
                    title: this.props.literals['L20006'],
                    nameText: this.props.literals['L20008'],
                    elements: []
                }
            }
        }
	}

    componentDidMount()
    {
        try
        {
            getOSHData('MATRIX_AUTHORITY', {countries: [this.state.country]})
                .then((res) => {
                    let authorities = [];
                    let compensationAndInsurance = [];
                    let preventionInstitute = [];
                    let standardisation = [];
                    res.resultset.forEach(element => {
                        // Text 1 is the name of the institution
                        // Text 2 contains the links for the website and the OSHWiki
                        // Text 3 is the long text
                        // Extract the link to the website and the OSHWiki from text2                        
                        let el = document.createElement("html");
                        el.innerHTML = this.props.literals[`L${element.text2}`];
                        let anchors = el.getElementsByTagName("a");
                        // The link for Links will have "website" text
                        // The links for OSHWiki will "OSHWiki" text
                        // The rest of the links will be in otherLinks
                        let links = [];
                        if (Array.prototype.slice.call( anchors ).filter(anchor => anchor.text=='website').length > 0)
                        {
                            Array.prototype.slice.call( anchors ).filter(anchor => anchor.text=='website').forEach( function(link) {
                                links.push (link.href);
                            });
                        }
                        let OSHWikiLink = "";
                        if (Array.prototype.slice.call( anchors ).filter(anchor => anchor.text=='OSHwiki').length == 1)
                        {
                            OSHWikiLink = Array.prototype.slice.call( anchors ).filter(anchor => anchor.text=='OSHwiki')[0].href;
                        }
                        let otherLinks = [];
                        if (Array.prototype.slice.call( anchors ).filter(anchor => anchor.text!='website' && anchor.text!='OSHwiki').length > 0)
                        {
                            Array.prototype.slice.call( anchors ).filter(anchor => anchor.text!='website' && anchor.text!='OSHwiki').forEach( function(link) {
                                otherLinks.push (link.href);
                            });
                        }

                        if (element.check1)
                        {
                            authorities.push({ links: links, oshWiki: OSHWikiLink, otherLinks: otherLinks, name: element.text1, text: element.text3 });
                        }
                        else if (element.check2)
                        {
                            compensationAndInsurance.push({ links: links, oshWiki: OSHWikiLink, otherLinks: otherLinks, name: element.text1, text: element.text3 });
                        }
                        else if (element.check3)
                        {
                            preventionInstitute.push({ links: links, oshWiki: OSHWikiLink, otherLinks: otherLinks, name: element.text1, text: element.text3 });
                        }
                        else if (element.check4)
                        {
                            standardisation.push({ links: links, oshWiki: OSHWikiLink, otherLinks: otherLinks, name: element.text1, text: element.text3 });
                        }
                    });
                    this.setState( { tableElements: {authorities: {...this.state.tableElements.authorities, elements: authorities },
                        compensationAndInsurance: {...this.state.tableElements.compensationAndInsurance, elements: compensationAndInsurance },
                        preventionInstitute: {...this.state.tableElements.preventionInstitute, elements: preventionInstitute },
                        standardisation: {...this.state.tableElements.standardisation, elements: standardisation }
                    }});
                }
            );
        }
        catch (error)
        {
            console.log('Error fetching data:', error)
        }
    }

    render()
    {
        return (
        <table className="osh-authorities-report">
            <thead>
                <tr>
                    <td className="header">
                        <div className="logo"></div>
                        <p>{ this.props.literals['L20001'] } — { this.props.literals[`L${this.state.country.countryName}`] }</p>
                    </td>
                </tr>
            </thead>
            <tbody className="osh-authorities-report-page">
                <tr>
                    <td>
                        <h1>{ this.props.literals['L20001'] } — { this.props.literals[`L${this.state.country.countryName}`] }</h1>
                        <p className="description">{ this.props.literals['L20002'] }</p>
                        <h2>{ this.props.literals[`L${this.state.country.countryName}`] }</h2>
                    </td>
                </tr>
                <tr>
                    <td>
                        { Object.keys(this.state.tableElements).map( (k, index) => (
                            ( this.state.tableElements[k].elements.length > 0 && (
                                <React.Fragment key={index}>
                                    <h3>{ this.state.tableElements[k].title }</h3>
                                    {this.state.tableElements[k].elements.map((element, index) => (
                                        <table key={index}>
                                            <tbody>
                                                <tr>
                                                    <th> { this.state.tableElements[k].nameText }</th>
                                                    <td className="name">{ ReactHtmlParser(this.props.literals[`L${ element.name }`]) }</td>
                                                </tr>
                                                {  element.links.length > 0 && (
                                                    <tr>
                                                        <th>{ this.props.literals['L20010'] }</th>
                                                        <td>
                                                            <ul className="links">
                                                                { element.links.map( (link, index) => (
                                                                    <li key={index}><a href={ link }>{ link }</a></li>
                                                                ))}                                                                
                                                            </ul>
                                                        </td>                                        
                                                    </tr>
                                                )}
                                                { this.props.literals[`L${ element.text }`].length > 0 && (
                                                    <tr>
                                                        <th>{ this.props.literals['L20011'] }</th>
                                                        <td>
                                                            { ReactHtmlParser(this.props.literals[`L${ element.text }`]) }
                                                        </td>
                                                    </tr>
                                                )}
                                                { element.oshWiki != "" && (
                                                    <tr>
                                                        <th>{ this.props.literals['L20012'] }</th>
                                                        <td>
                                                            <a href={ element.oshWiki }>{ element.oshWiki }</a>
                                                        </td>
                                                    </tr>
                                                )} 
                                                {  element.otherLinks.length > 0 && (
                                                    <tr>
                                                        <th>{ this.props.literals['L20013'] }</th>
                                                        <td>
                                                            <ul className="links">
                                                                { element.otherLinks.map( (link, index) => (
                                                                    <li key={index}><a href={ link }>{ link }</a></li>
                                                                ))}                                                                
                                                            </ul>
                                                        </td>                                        
                                                    </tr>
                                                )}                                              
                                            </tbody>
                                        </table>
                                    ))}
                                </React.Fragment>
                            ))                           
                        )) }
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <p className="">European Agency for Safety and Health at Work – EU-OSHA</p>
                    </td>
                </tr>
            </tfoot>
        </table>
        )
    }
}
OSHAuthoritiesReport.displayName='OSHAuthoritiesReport';
export default OSHAuthoritiesReport;